import { Application, Feature, Functionality } from '@frontend/functionality/types';
import { Route } from 'react-router-dom';

import { ApplicationBundleUsageLayout } from '../../components/application-bundle-usage-layout/application-bundle-usage-layout.component';
import { checkFeatureRoute, checkLicenseRoutes } from '../utils';
import { Inventory } from './inventory/inventory.component';
import { Items } from './items/items.component';
import { Labels } from './labels/labels.component';
import { ReceiveDirtyLaundry } from './receive-dirty-laundry/receive-dirty-laundry.component';
import { SendCleanLaundry } from './send-clean-laundry/send-clean-laundry.component';
import { Shipments } from './shipments/shipments.component';

export function ApplicationsLaundryRoutes(functionalities: Functionality[] | null) {
    const routeLicenseCheckResult = functionalities !== null ? checkLicenseRoutes(functionalities, Application.LAUNDRY) : null;

    if (routeLicenseCheckResult && !routeLicenseCheckResult.appEnabled) {
        return null;
    }

    return (
        <Route
            path='laundry'
            element={<ApplicationBundleUsageLayout application={Application.LAUNDRY} />}>
            {checkFeatureRoute(Feature.SCANNER, routeLicenseCheckResult) && (
                <Route
                    path='barcode_scanner'
                    element={
                        <div>
                            <h1>Barcode Scanner</h1>
                            <p>This is a placeholder for the barcode scanner component.</p>
                        </div>
                    }
                />
            )}
            {checkFeatureRoute(Feature.INBOUND_TRANSACTION, routeLicenseCheckResult) && (
                <Route
                    path='receive_dirty_laundry'
                    element={<ReceiveDirtyLaundry />}
                />
            )}
            {checkFeatureRoute(Feature.OUTBOUND_TRANSACTION, routeLicenseCheckResult) && (
                <Route
                    path='send_clean_laundry'
                    element={<SendCleanLaundry />}
                />
            )}
            {checkFeatureRoute(Feature.INVENTORY, routeLicenseCheckResult) && (
                <Route
                    path='inventory'
                    element={<Inventory />}
                />
            )}
            <Route
                path='items'
                element={<Items />}
            />
            <Route
                path='shipments'
                element={<Shipments />}
            />
            <Route
                path='labels'
                element={<Labels />}
            />
        </Route>
    );
}
